/* eslint-env browser */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

const subButton = document.querySelector('.swish__form');

function setIntervalX(callback, delay, repetitions) {
  let x = 0;
  const intervalID = window.setInterval(() => {
    callback();

    /* eslint-disable no-plusplus */
    if (x++ === repetitions) {
      window.clearInterval(intervalID);
    }
  }, delay);
}

function paymentResource(event) {
  event.preventDefault();

  const phone = document.querySelector('.phone');
  const amount = document.querySelector('.amount');

  if (phone && amount) {
    const formData = new FormData();
    formData.append('phone', phone.value);
    formData.append('amount', amount.value);

    fetch('/swish/createpayment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone: phone,
        amount: amount
      }),
    })
      .then((res) => res.json())
      .catch(((error) => {
        console.log(`Error: ${error}`);
      }));

    setIntervalX(() => {
      fetch('/swish/getpayment', {
        method: 'GET',
      })
        .then((res) => res.json())
        .then((data) => {
          document.querySelector('.el').style.display = 'none';
          document.querySelector('.process').classList.add('show');

          if (data.status === 'PAID') {
            document.querySelector('.process').classList.remove('show');
            document.querySelector('.paid').classList.add('show');
          }
        }).catch(((error) => {
        console.log(`Error: ${error}`);
      }));
    }, 1000, 200);
  }
}

if(subButton) {
  subButton.addEventListener('submit', paymentResource);
}
